module.exports = __webpack_public_path__ + "img/cul_5.4d0c9aad.png";